module.exports = __webpack_public_path__ + "img/accRecycleIntr1.058accfa.png";